/**
 * 模块名称: 消耗业绩详情更新
 */

import React, { useState, useEffect, useRef } from 'react'
import api from '@/api'
import moment from 'moment'
import {
  Table,
  Form,
  Icon,
  Input,
  Button,
  Select,
  Modal,
  message,
  Alert,
  DatePicker,
  Tooltip
} from 'antd'

import CorpFilter from 'components/CorpFilter'
import { parseSearch, cryptoParamsIntoUrl } from 'utils'
import Export from 'components/Export'
import Auth from '@/components/AuthMiddleware'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const { RangePicker, MonthPicker } = DatePicker

let pageSize = 10
let currentPage = 1
let companyId = []
let searchParamsTmp = {
  limit: pageSize,
  page: currentPage,
  companyId: companyId
}
let storeFilterName = ''
let storeFilterContent = {}
let allFilter = {}
let selectedIds = ''

const DetailListNew = (props) => {
  const { history, match, location } = props
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue } = props.form
  const productsRef = useRef()
  const [filterName, setFilterName] = useState(undefined)
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [totalNum, setTotalNum] = useState('')
  const [filter, setFilter] = useState({})
  const [loading, setLoading] = useState(false)
  const [departmentList, setDepartmentList] = useState([])
  const [filterModelvisible, setFilterModelvisible] = useState(false)
  const [filterContent, setFilterContent] = useState([])
  const [showAll, setShowAll] = useState(false)
  const [showExport, setShowExport] = useState(false)
  const [checkedIdArr, setCheckedIdArr] = useState([])
  const [authList, setAuthList] = useState([])//按钮权限
  const [statusValName, setStatusValName] = useState(undefined)
  const [flag, setFlag] = useState(false)
  const search = parseSearch(location.search)

  useEffect(() => {
    currentPage = search.page ? +search.page : 1
    pageSize = search.limit ? +search.limit : 10
    searchParamsTmp = {
      limit: pageSize,
      page: currentPage
    }
    storeFilterName = ''
    storeFilterContent = {}
    getListFilter()
    getPerformanceConsumList()
    getPageAuth()
  }, [])

  //按钮权限
  const getPageAuth = () => {
    api.getPageAuth().then(list => {
      setAuthList(list)
    })
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    }
  }

  //点击选择所属公司
  const onChangeCorp = (data) => {
    //console.log('onChangeCorp', data)
    setDepartmentList([])
    setFieldsValue({ 'departmentId': undefined })
    currentPage = 1
    history.replace(match.path)
    if (data.length) {
      let arr = []
      data.forEach(item => {
        arr.push(item.id)
      })
      companyId = [].concat(arr)
      searchParamsTmp = {
        limit: pageSize,
        page: currentPage,
        companyId: companyId
      }
    } else {
      companyId = []
      searchParamsTmp = {
        limit: pageSize,
        page: currentPage
      }
    }
    getPerformanceConsumList()
  }
  //点击重置
  const onReset = () => {
    currentPage = 1
    history.replace(match.path)
    searchParamsTmp = {
      limit: pageSize,
      page: currentPage,
      companyId: companyId
    }
    resetFields()
    setFilterName(undefined)
    setStatusValName(undefined)
    getPerformanceConsumList()
  }

  //分页点击
  const onChangeTable = (pagination, filters, sorter) => {
    searchParamsTmp.page = currentPage = pagination.current
    searchParamsTmp.limit = pageSize = pagination.pageSize
    history.replace(match.path + '?page=' + currentPage + '&limit=' + pageSize)
    getPerformanceConsumList()
  }

  //获取列表
  const getPerformanceConsumList = () => {
    setLoading(true)
    if (companyId.length) searchParamsTmp.companyId = companyId
    api.getPerformanceConsumList(searchParamsTmp).then(res => {
      if (res.list) {
        setTotalNum(res)
        setCount(res.list.count)
        setList(res.list.list)
      }
      setLoading(false)
    }).catch(() => {
      setLoading(false)
    })
  }

  //获取筛选项
  const getListFilter = () => {
    api.perfPersonListFilter().then(res => {
      setFilter(res)
    }).catch(() => {
    })
  }
  //获取部门列表
  const getDepartmentList = () => {
    api.getDepartment({ limit: global.paramsLimit, companyId }).then(res => {
      setDepartmentList(res.list)
    })
  }

  //数据转换
  const transData = (vals) => {
    if (vals !== undefined) {
      for (let i in vals) {
        if (vals[i] !== undefined) {
          if (i == 'consumDate') {
            searchParamsTmp.createTimeMin = moment(vals[i][0]).format('YYYY-MM-DD')
            searchParamsTmp.createTimeMax = moment(vals[i][1]).format('YYYY-MM-DD')
          } else if (i == 'consumptionPerformanceMonth') {
            searchParamsTmp.consumptionPerformanceMonth = moment(vals[i]).format('YYYY年MM月')
          } else {
            searchParamsTmp[i] = vals[i]
          }
          // console.log(searchParamsTmp)
        }
      }
    }
  }
  //点击筛选
  const searchSubmit = (e) => {
    e.preventDefault()
    validateFields((err, vals) => {
      //console.log(vals)
      transData(vals)
      if (!err) {
        searchParamsTmp.page = currentPage = 1
        history.replace(match.path)
        getPerformanceConsumList()
        setFilterName(undefined)
      }
    })
  }
  //选择保存方案
  const onChangeGetFilter = (val) => {
    val ? setFlag(true) : setFlag(false)
    // 下拉框搜索内容
    val && api.getSearchStorage({ key: location.pathname }).then(res => {
      setFilterContent(res.list)
    })
  }
  //选择方案
  const onFilterChecked = (item, val2) => {
    // console.log('item=>', item)
    setFilterName(item)
    setStatusValName(val2.props.children.props.children[0])
    let data = filterContent[item].content
    searchParamsTmp = { ...searchParamsTmp, ...data }
    setFieldsValue({
      companyId: data.companyId ? data.companyId : undefined,
      staffNumber: data.staffNumber ? data.staffNumber : undefined,
      staffName: data.staffName ? data.staffName : undefined,
      orderNumber: data.orderNumber ? data.orderNumber : undefined,
      staffJobPosition: data.staffJobPosition ? data.staffJobPosition : undefined,
      departmentId: data.departmentId ? data.departmentId : undefined,
      staffGroupId: data.staffGroupId ? data.staffGroupId : undefined,
      staffLeaderName: data.staffLeaderName ? data.staffLeaderName : undefined,
      staffIsOnJob: data.staffIsOnJob ? data.staffIsOnJob : undefined,
      orderType: data.orderType ? data.orderType : undefined,
      orderMajorType: data.orderMajorType ? data.orderMajorType : undefined,
      orderFigureType: data.orderFigureType ? data.orderFigureType : undefined,
      // performanceId: data.performanceId ? data.performanceId : undefined,
      clientId: data.clientId ? data.clientId : undefined,
      clientName: data.clientName ? data.clientName : undefined,
      type: data.type ? data.type : undefined,
      consumptionPerformanceMonth: data.consumptionPerformanceMonth ? moment(data.consumptionPerformanceMonth) : undefined,
      vendor: data.vendor ? data.vendor : undefined,

      consumDate: data.consumDate ? [moment(data.consumDate[0]), moment(data.consumDate[1])] : undefined
    })
    getDepartmentList()
  }

  // 筛选删除
  const onSearchDelete = (id) => {
    api.searchStorageDelete({
      id: id
    }).then(() => {
      api.getSearchStorage({ key: location.pathname }).then(data => {
        setFilterContent(data.list)
      })
    })
  }

  //保存筛选条件
  const onSaveFilterTerm = () => {
    validateFields((err, vals) => {
      //console.log(vals)
      if (!err) {
        const values = Object.values(vals)
        if (values.some(item => item === '' || item !== undefined)) {
          storeFilterContent = {}
          for (let k in vals) {//eslint-disable-line
            if (vals[k] !== undefined) {
              if (k === 'consumDate') {
                storeFilterContent[k] = [moment(vals[k][0]).format('YYYY-MM-DD'), moment(vals[k][1]).format('YYYY-MM-DD')]
              } else {
                storeFilterContent[k] = vals[k]
              }
            }
          }
          setFilterModelvisible(true)
        } else {
          message.error('请选择筛选内容')
        }
      }
    })
  }
  //保存筛选点击确定
  const filterHandleOk = () => {
    validateFields((err, vals) => {
      api.saveSearchStorage({
        name: storeFilterName,
        key: location.pathname,
        content: storeFilterContent
      }).then(() => {
        setFilterModelvisible(false)
        message.success('添加成功')
      })
    })
  }
  //取消筛选点击确定
  const filterHandleCancel = () => {
    setFilterModelvisible(false)
  }
  //修改筛选名称
  const onFilterInfoChange = (e) => {
    storeFilterName = e.target.value
  }

  //导出
  const onExportFile = () => {
    setShowExport(true)
    allFilter = Object.assign({}, searchParamsTmp)
    for (let i in allFilter) {
      if (i == 'page' || i == 'limit') delete allFilter[i]
    }
    if (allFilter.companyId && allFilter.companyId.length > 0) {
      if (!Array.isArray(allFilter.companyId)) {
        allFilter.companyId = allFilter.companyId.split(',')
      }
    } else {
      allFilter.companyId = []
    }
    // console.log(allFilter)
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      //console.log(selectedRowKeys, selectedRows)
      selectedIds = selectedRowKeys
    },
    onSelect: (record, selected, selectedRows) => {
      // console.log(record, selected, selectedRows)
      if (!selected) {
        for (let i = 0; i < checkedIdArr.length; i++) {
          if (checkedIdArr[i] == record.id) {//eslint-disable-line
            checkedIdArr.splice(i, 1)
            i--
          }
        }
      } else {
        checkedIdArr.push(record.id)
      }
      let arrNew = [...new Set(checkedIdArr)]
      setCheckedIdArr(arrNew)
      selectedIds = arrNew
    },
    getCheckboxProps: record => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
    //全选一列（默认十条）
    onSelectAll: (selected, selectedRows, changeRows) => {
      //console.log(selected, selectedRows, changeRows)
      let arr = []
      changeRows.forEach(item => {
        arr.push(item.id)
      })
      if (selected) {
        setCheckedIdArr([...new Set([...checkedIdArr, ...arr])])
      } else {
        setCheckedIdArr(checkedIdArr.filter(item => !arr.includes(item)))
      }
    },
    selectedRowKeys: checkedIdArr
  }

  return (
    <>
      <CorpFilter onChange={onChangeCorp} />
      <div className="search-askforleave-wrap">
        <h4 className="title">其他选项：</h4>
        {
          !showAll ? <span className="askforleave-filter-control" onClick={() => setShowAll(true)}>展开<Icon type="down" /></span>
            : <span className="askforleave-filter-control" onClick={() => setShowAll(false)}>收起<Icon type="up" /></span>
        }
        <Form onSubmit={searchSubmit} {...formItemLayout}>
          <div className={`form-box${showAll ? ' askforleave-form-auto' : ''}`}>
            <FormItem label="员工编号">
              {getFieldDecorator('staffNumber')(<Input
                placeholder="请输入员工编号"
              />)}
            </FormItem>
            <FormItem label="公司用名">
              {getFieldDecorator('staffName')(<Input
                placeholder="请输入员工姓名"
              />)}
            </FormItem>
            <FormItem label="关联订单">
              {getFieldDecorator('orderNumber')(<Input
                placeholder="请输入订单编号"
              />)}
            </FormItem>
            <FormItem label="职位">
              {getFieldDecorator('staffJobPosition')(<Select
                placeholder="全部"
                dropdownMatchSelectWidth={false}
              >
                {
                  filter.position && filter.position.map((item, index) => {
                    return <Option key={item.id}>{item.name}</Option>
                  })
                }
              </Select>)}
            </FormItem>
            <FormItem label="部门">
              {getFieldDecorator('departmentId')(<Select
                placeholder="全部"
                onDropdownVisibleChange={bool => bool && getDepartmentList()}
                showSearch
                optionFilterProp="children"
                dropdownMatchSelectWidth={false}
              >
                {
                  departmentList.map(v => {
                    return !companyId.length ? <Option title={v.name + '（' + v.companyName + '）'} key={v.id}>{v.name}（{v.companyName}）</Option> : <Option title={v.name} key={v.id}>{v.name}</Option>
                  })
                }
              </Select>)}
            </FormItem>
            <FormItem label="事业群">
              {getFieldDecorator('staffGroupId')(<Select
                placeholder="全部"
                showSearch
                optionFilterProp="children"
                dropdownMatchSelectWidth={false}
              >
                {
                  filter.group && filter.group.map((item, index) => {
                    return <Option key={item.id}>{item.name}</Option>
                  })
                }
              </Select>)}
            </FormItem>
            <FormItem label="直接主管">
              {getFieldDecorator('staffLeaderName')(<Input
                placeholder="请输入直接主管"
              />)}
            </FormItem>
            <FormItem label="员工状态">
              {getFieldDecorator('staffIsOnJob')(<Select
                placeholder="全部"
              >
                {
                  filter.staffSta && filter.staffSta.map((item, index) => {
                    return <Option key={item.id}>{item.name}</Option>
                  })
                }
              </Select>)}
            </FormItem>
            <FormItem label="订单类型">
              {getFieldDecorator('orderType')(<Select
                placeholder="全部"
                dropdownMatchSelectWidth={false}
              >
                {
                  filter.orderType && filter.orderType.map((item, index) => {
                    return <Option key={item.id}>{item.name}</Option>
                  })
                }
              </Select>)}
            </FormItem>
            <FormItem label="主/副项">
              {getFieldDecorator('orderMajorType')(<Select
                placeholder="全部"
                dropdownMatchSelectWidth={false}
              >
                {
                  filter.major && filter.major.map((item, index) => {
                    return <Option key={item.id}>{item.name}</Option>
                  })
                }
              </Select>)}
            </FormItem>
            <FormItem label="业绩类型">
              {getFieldDecorator('orderFigureType')(<Select
                placeholder="全部"
                dropdownMatchSelectWidth={false}
              >
                {
                  filter.profitType && filter.profitType.map((item, index) => {
                    return <Option key={item.id}>{item.name}</Option>
                  })
                }
              </Select>)}
            </FormItem>
            {/* <FormItem label="关联订单业绩">
              {getFieldDecorator('performanceId')(<Input
                placeholder="请输入订单业绩ID"
              />)}
            </FormItem> */}
            <FormItem label="客户ID">
              {getFieldDecorator('clientId')(<Input
                placeholder="请输入客户OAID"
              />)}
            </FormItem>
            <FormItem label="客户名称">
              {getFieldDecorator('clientName')(<Input
                placeholder="请输入客户名称"
              />)}
            </FormItem>
            <FormItem label="业绩来源">
              {getFieldDecorator('type')(<Select
                placeholder="全部"
                dropdownMatchSelectWidth={false}
              >
                {
                  filter.consumPerformanceSource && filter.consumPerformanceSource.map((item, index) => {
                    return <Option key={item.id}>{item.name}</Option>
                  })
                }
              </Select>)}
            </FormItem>
            <FormItem label="消耗业绩月份">
              {getFieldDecorator('consumptionPerformanceMonth')(
                <MonthPicker placeholder="请选择" allowClear={false} />
              )}
            </FormItem>
            <FormItem label="厂商ID">
              {getFieldDecorator('vendor')(<Input
                placeholder="请输入厂商ID"
              />)}
            </FormItem>
            <FormItem label="消耗业绩生成时间" style={{ width: '40%' }}>
              {getFieldDecorator('consumDate', {
              })(<RangePicker allowClear={false} />)}
            </FormItem>
          </div>
          <FormItem className="btns" label=" " colon={false}>
            <div className="staff-filter-btns">
              {showAll && <>
                <h4 className="filter-title">已保存筛选方案：</h4>
                <div className="filter-select">
                  <Select style={{ display: 'inline-block', width: '160px' }} placeholder="请选择" onDropdownVisibleChange={bool => bool && onChangeGetFilter(bool)} onSelect={onFilterChecked} value={filterName}>
                    {filterContent.map((item, index) =>
                      <Option value={index} key={index}>
                        <div className="closeStyBtn">
                          {item.name}
                          {flag && statusValName !== item.name ? <span className="closeSpan"><Icon style={{ fontSize: '10px', color: '#1890ff' }} type="close" onClick={e => {
                            e.stopPropagation()
                            onSearchDelete(item.id)
                          }} /></span> : null}
                        </div>
                      </Option>
                    )}
                  </Select>
                </div>
                <Button className="filter-savebtn" onClick={onSaveFilterTerm}>保存筛选条件</Button>
              </>}
              <Auth auths={authList} code="export">
                <Tooltip title="导出" placement="bottom">
                  <Button type="primary" icon="upload" onClick={onExportFile} style={{ marginLeft: 15 }}>导出</Button>
                </Tooltip>
              </Auth>
              <Button onClick={onReset}>重置</Button>
              <Button type="primary" htmlType="submit">筛选</Button>
              <Modal
                title="保存筛选条件"
                visible={filterModelvisible}
                onOk={filterHandleOk}
                onCancel={filterHandleCancel}
              >
                <Input placeholder="请输入筛选名称" onChange={onFilterInfoChange} />
              </Modal>
            </div>
          </FormItem>
        </Form>
      </div>
      <div className="line"></div>
      <div className="add-wrap">
      </div>
      <Export
        show={showExport}
        onCancel={() => {
          setShowExport(false)
          productsRef.current.changeVal()
        }}
        tplUrl="getPerfConsumExportTpl"
        fieldsUrl="getPerfConsumTplItems"
        saveUrl="savePerfConsumExportTpls"
        exportUrl="exportPerfConsumAdj"
        method="export"
        parame={{ ExportType: 'performanceconsum.export', id: selectedIds, ...allFilter }}
        type={1}
        cRef={productsRef}
      />

      <Alert className="corp-count" message={<>
        <span>{`总计：${count}条数据`}</span>
        <span style={{ marginLeft: '20px' }}>{`合计消耗业绩：${totalNum.totalConsumption ? totalNum.totalConsumption : 0} `}</span>
        <span style={{ marginLeft: '20px' }}>{`新开消耗业绩：${totalNum.newConsumption ? totalNum.newConsumption : 0} `}</span>
        <span style={{ marginLeft: '20px' }}>{`续费消耗业绩：${totalNum.renewConsumption ? totalNum.renewConsumption : 0} `}</span>
      </>} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey="id"
        loading={loading}
        className="askforleave-table"
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        scroll={{ x: 2600 }}
        rowSelection={rowSelection}
      >
        <Column title="消耗业绩月份" dataIndex="consumptionPerformanceMonth" fixed="left" />
        <Column title="消耗业绩生成时间" dataIndex="createTime" fixed="left" width={110} />
        <Column title="关联订单编号" dataIndex="orderNumber" render={(text, record) =>
          <>
            {
              <a target='_blank' href={cryptoParamsIntoUrl(`/order${record.orderType == '0' ? 'Direct/direct' : 'Agent/agent'}Detail`, { id: record.orderId })}>{text}</a>
            }
          </>
        } />
        <Column title="客户名称" dataIndex="clientName" />
        <Column title="订单类型" dataIndex="orderType" render={(text, record) => <>{record.orderType == 0 ? '直销' : '代理商'}</>} />
        <Column title="主项/副项" dataIndex="orderMajorTypeName" />
        <Column title="消耗业绩类型" dataIndex="orderFigureTypeName" />
        <Column title="总消耗业绩" dataIndex="conprTotal" />
        <Column title="新开消耗业绩" dataIndex="conprBill" />
        <Column title="续费消耗业绩" dataIndex="conprRebill" />
        <Column title="业绩抵减项" dataIndex="conprDeduct" />
        <Column title="消耗对应市场价" dataIndex="conprMarketprice" />
        <Column title="消耗对应实收" dataIndex="conprActural" />
        <Column title="消耗对应成本" dataIndex="conprCost" />
        <Column title="消耗对应调整项" dataIndex="conprRefund" />
        <Column title="订单折扣" dataIndex="orderDiscount" />
        <Column title="业绩分成占比" dataIndex="conprRate" />
        <Column title="员工编号" dataIndex="staffNumber" width={120} />
        <Column title="公司用名" dataIndex="staffName" />
        <Column title="所属部门" dataIndex="staffDepartmentName" />
        <Column title="直接主管" dataIndex="staffLeaderName" />
        <Column title="职位" dataIndex="staffJobPositionName" />
        <Column title="岗位级别" dataIndex="staffJobStationName" />
        <Column title="员工状态" dataIndex="staffIsOnJobName" />
      </Table>
    </>
  )
}

export default Form.create()(DetailListNew)